import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import  ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function RBMA({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  return (

<div className="wrapper">
	<Helmet>
	    <meta charSet="utf-8" />
	    <title>Maria Chimishkyan — {ProjectModel.RBMA.title}</title>
	</Helmet>

	<div className="inner-wrapper">
		<Container fluid className="page-pad">
			<Row>
				<Col sm={3}>
					<div className="description-sticky">
					  <ProjectDescription projectModel={ProjectModel.RBMA}/>
					</div>
				</Col>
				<Col sm={6}>
					<video className="reg" loop autoPlay muted playsInline style={{ objectFit: 'contain', width: '100%' }}
					src="img/project-page/rbma/RBMA_Rhythm_MariaChimishkyan.mp4"
					alt="RBMA - Rhythm — Maria Chimishkyan"/>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/rbma/RBMA-1999-MariaChimishkyan.gif" alt="RBMA - 1999 — Maria Chimishkyan" style={{ width: '100%' }}/>
							<div className="project-caption">1999</div>
						</div>
						<div>
							<img src="img/project-page/rbma/RBMA-MusicInFilm-MariaChimishkyan.gif" alt="RBMA - Music In Film — Maria Chimishkyan" style={{ width: '100%' }}/>
							<div className="project-caption">Music In Film</div>
						</div>
					</div>
					</div>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/rbma/RBMA-Fashion-MariaChimishkyan.gif" alt="RBMA - Fashion — Maria Chimishkyan" style={{ width: '100%' }}/>
							<div className="project-caption">Fashion</div>
						</div>
						<div>
							<img src="img/project-page/rbma/RBMA-DIY-MariaChimishkyan.gif" alt="RBMA - DIY — Maria Chimishkyan" style={{ width: '100%' }}/>
							<div className="project-caption">DIY</div>
						</div>
					</div>
					</div>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/rbma/RBMA-Detroit-MariaChimishkyan.gif" alt="RBMA - Detroit — Maria Chimishkyan" style={{ width: '100%' }}/>
							<div className="project-caption">Detroit</div>
						</div>
						<div>
							<img src="img/project-page/rbma/RBMA-AvantGarde-MariaChimishkyan.gif" alt="RBMA - Avant Garde — Maria Chimishkyan" style={{ width: '100%' }}/>
							<div className="project-caption">Avante Garde</div>
						</div>
					</div>
					</div>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/rbma/RBMA-Rhythm-MariaChimishkyan.gif" alt="RBMA - Rhythm — Maria Chimishkyan" style={{ width: '100%' }}/>
							<div className="project-caption">Rhythm</div>
						</div>
						<div>
							<img src="img/project-page/rbma/RBMA-Afrofuturism-MariaChimishkyan.gif" alt="RBMA - Afrofuturism — Maria Chimishkyan" style={{ width: '100%' }}/>
							<div className="project-caption">Afrofuturism</div>
						</div>
					</div>
					</div>
				</Col>
			</Row>
		</Container>
	</div>
	<ProjectIndex/>
</div>
  )
}

export default connect()(RBMA);
